div.file-row.odd{background:#cce5ff}div.file-row{padding:10px 0}div.file-row button{margin-left:5px}.progress{background:none;border:1px #ccc solid}.percentTag{text-align:right!important;color:#000;align-items:center}.fa-remove{display:block;float:right}
/*# sourceMappingURL=file-upload.component-H3RO3WUB.css.map */
